var _defs, _path, _path2, _path3, _line, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0077bf;}.cls-2{fill:none;stroke:#0077bf;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TransferCash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.5,2A44.5,44.5,0,1,1,2,46.5,44.55,44.55,0,0,1,46.5,2m0-2A46.5,46.5,0,1,0,93,46.5,46.5,46.5,0,0,0,46.5,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.62,53.46c3.11,0,5.19-1.82,5.19-5.19s-2.59-3.89-2.59-3.89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.06,37.63H37.49a8.13,8.13,0,0,0-10.38-5.19L29.71,40A15.8,15.8,0,0,0,23,48H16.74V61H24a15.84,15.84,0,0,0,8.3,7v6h7.78V68.76H50.46V74h7.78V68a15.63,15.63,0,0,0-5.19-30.35Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.68,
    y1: 45.42,
    x2: 53.06,
    y2: 45.42
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 47.87,
    cy: 22.07,
    r: 5.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferCash);
export default __webpack_public_path__ + "static/media/TransferCash.c25c482b5dd288fccd68fa6fb560ec76.svg";
export { ForwardRef as ReactComponent };